export default __webpack_public_path__ + "static/media/logo_flixtrain.9d0211da.svg";